import type {
    AccountClient,
    AccountCrudClient,
    AppFeatureClient,
    AppFeatureCrudClient,
    AppPackageClient,
    AppPackageFeatureClient,
    AppPackageFeatureCrudClient,
    AppPackageCrudClient,
    AppPackagePricingClient,
    AppPackagePricingCrudClient,
    AppUserPermissionClient,
    AppUserPermissionCrudClient,
    AssetLiabilityItemClient,
    AssetLiabilityItemCrudClient,
    AuditLogClient,
    AuditLogCrudClient,
    AuthClient,
    BrickflowEventLogClient,
    BrickflowEventLogCrudClient,
    BridgingDealClient,
    BridgingDealCrudClient,
    BridgingSearchClient,
    BridgingSearchCriteriaClient,
    CaseClient,
    CaseLenderClient,
    CaseLenderMessageClient,
    CaseLenderMessageCrudClient,
    CaseLenderMessageTrackClient,
    CaseLenderMessageTrackCrudClient,
    CaseLenderCrudClient,
    CaseMemberClient,
    CaseMemberCrudClient,
    CaseNoteClient,
    CaseNoteCrudClient,
    CaseCrudClient,
    ClaimClient,
    ClientClient,
    ClientCrudClient,
    CommercialDealClient,
    CommercialDealCrudClient,
    CommercialSearchResultsClient,
    ComparablePropertyClient,
    ComparablePropertyCrudClient,
    DashboardClient,
    DealClient,
    DealClientClient,
    DealClientCrudClient,
    DealCompletionClient,
    DealCompletionCrudClient,
    DealFileAttachmentClient,
    DealFileAttachmentCrudClient,
    DealLenderClient,
    DealLenderMessageClient,
    DealLenderMessageCrudClient,
    DealLenderMessageTrackClient,
    DealLenderMessageTrackCrudClient,
    DealLenderCrudClient,
    DealNoteClient,
    DealNoteCrudClient,
    DealCrudClient,
    DealScheduleClient,
    DealScheduleCrudClient,
    DeveloperExitFinanceDevScheduleInputClient,
    DeveloperExitFinanceDevScheduleInputCrudClient,
    DeveloperExitFinanceLoanInputClient,
    DeveloperExitFinanceLoanInputCrudClient,
    DevelopmentInputClient,
    DevelopmentInputCrudClient,
    DevelopmentInputScheduleCrudClient,
    DevelopmentInputWithNoLoginClient,
    DevelopmentInputWithNoLoginCrudClient,
    DevelopmentTrackRecordClient,
    DevelopmentTrackRecordCrudClient,
    DevelopmentFinanceDealClient,
    DevFinanceSearchClient,
    ExternalApiClient,
    ExternalLinksClient,
    ExternalLinksCrudClient,
    FeedBackClient,
    FeedBackCrudClient,
    FileAttachmentClient,
    FileAttachmentCrudClient,
    IntroducerClient,
    IntroducerCrudClient,
    IntroducerSimpleClient,
    InviteClient,
    InviteCrudClient,
    LenderClient,
    LenderCrudClient,
    LenderOrganisationClient,
    LenderOrganisationCrudClient,
    LenderResultClient,
    LenderResultCrudClient,
    LicenseAppPackageClient,
    LicenseAppPackageCrudClient,
    LicenseMasterClient,
    LicenseMasterCrudClient,
    MagicLinkClient,
    MetadataClient,
    OrganisationClient,
    OrganisationLinkClient,
    OrganisationLinkCrudClient,
    OrganisationCrudClient,
    OTPClient,
    PaymentClient,
    PostcodeLocationClient,
    PostcodeLocationCrudClient,
    ProductClient,
    ProductCrudClient,
    ProductRateClient,
    ProductRateCrudClient,
    ProfileClient,
    ProfileAssetLiabilityItemClient,
    ProfileAssetLiabilityItemCrudClient,
    ProfileCrudClient,
    ProjectOwnershipClient,
    ProjectOwnershipCrudClient,
    QualificationsClient,
    QualificationsCrudClient,
    RoleClient,
    ScheduledJobLogClient,
    ScheduledJobLogCrudClient,
    SelectedResultClient,
    SelectedResultCrudClient,
    SnapshotLenderClient,
    SnapshotLenderCrudClient,
    SnapshotProductClient,
    SnapshotProductCrudClient,
    SnapshotSearchResultClient,
    SnapshotSearchResultCrudClient,
    StaticDataClient,
    StreetAddressClient,
    TaskItemClient,
    TaskItemCrudClient,
    TeamMemberClient,
    TeamMemberCrudClient,
    ThirdPartyApiAccessKeyClient,
    ThirdPartyApiAccessKeyCrudClient,
    UserClient,
} from '@src/apis/ModularClient';
import { createContext, useContext } from 'react';

type APIs = {
    accountClient: AccountClient,
    appFeatureClient: AppFeatureClient,
    appPackageClient: AppPackageClient,
    appPackageFeatureClient: AppPackageFeatureClient,
    appPackagePricingClient: AppPackagePricingClient,
    appUserPermissionClient: AppUserPermissionClient,
    assetLiabilityItemClient: AssetLiabilityItemClient,
    auditLogClient: AuditLogClient,
    authClient: AuthClient,
    brickflowEventLogClient: BrickflowEventLogClient,
    bridgingDealClient: BridgingDealClient,
    bridgingSearchClient: BridgingSearchClient,
    bridgingSearchCriteriaClient: BridgingSearchCriteriaClient,
    caseClient: CaseClient,
    caseLenderClient: CaseLenderClient,
    caseLenderMessageClient: CaseLenderMessageClient,
    caseLenderMessageTrackClient: CaseLenderMessageTrackClient,
    caseMemberClient: CaseMemberClient,
    caseNoteClient: CaseNoteClient,
    claimClient: ClaimClient,
    clientClient: ClientClient,
    commercialDealClient: CommercialDealClient,
    commercialSearchResultsClient: CommercialSearchResultsClient,
    comparablePropertyClient: ComparablePropertyClient,
    dashboardClient: DashboardClient,
    dealClient: DealClient,
    dealClientClient: DealClientClient,
    dealCompletionClient: DealCompletionClient,
    dealFileAttachmentClient: DealFileAttachmentClient,
    dealLenderClient: DealLenderClient,
    dealLenderMessageClient: DealLenderMessageClient,
    dealLenderMessageTrackClient: DealLenderMessageTrackClient,
    dealNoteClient: DealNoteClient,
    dealScheduleClient: DealScheduleClient,
    developerExitFinanceDevScheduleInputClient: DeveloperExitFinanceDevScheduleInputClient,
    developerExitFinanceLoanInputClient: DeveloperExitFinanceLoanInputClient,
    developmentInputClient: DevelopmentInputClient,
    developmentInputWithNoLoginClient: DevelopmentInputWithNoLoginClient,
    developmentTrackRecordClient: DevelopmentTrackRecordClient,
    developmentFinanceDealClient: DevelopmentFinanceDealClient,
    devFinanceSearchClient: DevFinanceSearchClient,
    externalApiClient: ExternalApiClient,
    externalLinksClient: ExternalLinksClient,
    feedBackClient: FeedBackClient,
    fileAttachmentClient: FileAttachmentClient,
    introducerClient: IntroducerClient,
    introducerSimpleClient: IntroducerSimpleClient,
    inviteClient: InviteClient,
    lenderClient: LenderClient,
    lenderOrganisationClient: LenderOrganisationClient,
    lenderResultClient: LenderResultClient,
    licenseAppPackageClient: LicenseAppPackageClient,
    licenseMasterClient: LicenseMasterClient,
    magicLinkClient: MagicLinkClient,
    metadataClient: MetadataClient,
    organisationClient: OrganisationClient,
    organisationLinkClient: OrganisationLinkClient,
    OTPClient: OTPClient,
    paymentClient: PaymentClient,
    postcodeLocationClient: PostcodeLocationClient,
    productClient: ProductClient,
    productRateClient: ProductRateClient,
    profileClient: ProfileClient,
    profileAssetLiabilityItemClient: ProfileAssetLiabilityItemClient,
    projectOwnershipClient: ProjectOwnershipClient,
    qualificationsClient: QualificationsClient,
    roleClient: RoleClient,
    scheduledJobLogClient: ScheduledJobLogClient,
    selectedResultClient: SelectedResultClient,
    snapshotLenderClient: SnapshotLenderClient,
    snapshotProductClient: SnapshotProductClient,
    snapshotSearchResultClient: SnapshotSearchResultClient,
    staticDataClient: StaticDataClient,
    streetAddressClient: StreetAddressClient,
    taskItemClient: TaskItemClient,
    teamMemberClient: TeamMemberClient,
    thirdPartyApiAccessKeyClient: ThirdPartyApiAccessKeyClient,
    userClient: UserClient,

    accountCrudClient: AccountCrudClient,
    appFeatureCrudClient: AppFeatureCrudClient,
    appPackageFeatureCrudClient: AppPackageFeatureCrudClient,
    appPackageCrudClient: AppPackageCrudClient,
    appPackagePricingCrudClient: AppPackagePricingCrudClient,
    appUserPermissionCrudClient: AppUserPermissionCrudClient,
    assetLiabilityItemCrudClient: AssetLiabilityItemCrudClient,
    auditLogCrudClient: AuditLogCrudClient,
    brickflowEventLogCrudClient: BrickflowEventLogCrudClient,
    bridgingDealCrudClient: BridgingDealCrudClient,
    caseLenderMessageCrudClient: CaseLenderMessageCrudClient,
    caseLenderMessageTrackCrudClient: CaseLenderMessageTrackCrudClient,
    caseLenderCrudClient: CaseLenderCrudClient,
    caseMemberCrudClient: CaseMemberCrudClient,
    caseNoteCrudClient: CaseNoteCrudClient,
    caseCrudClient: CaseCrudClient,
    clientCrudClient: ClientCrudClient,
    commercialDealCrudClient: CommercialDealCrudClient,
    comparablePropertyCrudClient: ComparablePropertyCrudClient,
    dealClientCrudClient: DealClientCrudClient,
    dealCompletionCrudClient: DealCompletionCrudClient,
    dealFileAttachmentCrudClient: DealFileAttachmentCrudClient,
    dealLenderMessageCrudClient: DealLenderMessageCrudClient,
    dealLenderMessageTrackCrudClient: DealLenderMessageTrackCrudClient,
    dealLenderCrudClient: DealLenderCrudClient,
    dealNoteCrudClient: DealNoteCrudClient,
    dealCrudClient: DealCrudClient,
    dealScheduleCrudClient: DealScheduleCrudClient,
    developerExitFinanceDevScheduleInputCrudClient: DeveloperExitFinanceDevScheduleInputCrudClient,
    developerExitFinanceLoanInputCrudClient: DeveloperExitFinanceLoanInputCrudClient,
    developmentInputCrudClient: DevelopmentInputCrudClient,
    developmentInputScheduleCrudClient: DevelopmentInputScheduleCrudClient,
    developmentInputWithNoLoginCrudClient: DevelopmentInputWithNoLoginCrudClient,
    developmentTrackRecordCrudClient: DevelopmentTrackRecordCrudClient,
    externalLinksCrudClient: ExternalLinksCrudClient,
    feedBackCrudClient: FeedBackCrudClient,
    fileAttachmentCrudClient: FileAttachmentCrudClient,
    introducerCrudClient: IntroducerCrudClient,
    inviteCrudClient: InviteCrudClient,
    lenderCrudClient: LenderCrudClient,
    lenderOrganisationCrudClient: LenderOrganisationCrudClient,
    lenderResultCrudClient: LenderResultCrudClient,
    licenseAppPackageCrudClient: LicenseAppPackageCrudClient,
    licenseMasterCrudClient: LicenseMasterCrudClient,
    organisationLinkCrudClient: OrganisationLinkCrudClient,
    organisationCrudClient: OrganisationCrudClient,
    postcodeLocationCrudClient: PostcodeLocationCrudClient,
    productCrudClient: ProductCrudClient,
    productRateCrudClient: ProductRateCrudClient,
    profileAssetLiabilityItemCrudClient: ProfileAssetLiabilityItemCrudClient,
    profileCrudClient: ProfileCrudClient,
    projectOwnershipCrudClient: ProjectOwnershipCrudClient,
    qualificationsCrudClient: QualificationsCrudClient,
    scheduledJobLogCrudClient: ScheduledJobLogCrudClient,
    selectedResultCrudClient: SelectedResultCrudClient,
    snapshotLenderCrudClient: SnapshotLenderCrudClient,
    snapshotProductCrudClient: SnapshotProductCrudClient,
    snapshotSearchResultCrudClient: SnapshotSearchResultCrudClient,
    taskItemCrudClient: TaskItemCrudClient,
    teamMemberCrudClient: TeamMemberCrudClient,
    thirdPartyApiAccessKeyCrudClient: ThirdPartyApiAccessKeyCrudClient,
}

export const APIContext = createContext<APIs | null>(null);

export const useAPIs = () => {
    const apis = useContext(APIContext);
    if (apis === null) throw new Error('Cannot access CCQ APIs outside an APIProvider');
    return apis;
}
